import ForceChallenge from './components/force-challenge';
import VerificationChallenge from './components/verification-challenge';
import SelectDeliveryMethod from './components/selectphones';

export const routes = [
  { path: '/forcechallenge', name: 'force-challenge', component: ForceChallenge, display: '', style: '' },
  { path: '/verification', name: 'verification-challenge', component: VerificationChallenge, display: '', style: '' },
  { path: '/forcechallenge/selectdeliverymethod', name: 'select-delivery-method', component: SelectDeliveryMethod, display: '', style: '' }
];
